import React, { useState } from 'react';
import DayPicker from 'react-day-picker';
import classNameBind from 'classnames/bind';
import 'react-day-picker/lib/style.css';

import defaultClassNames from './defaultClassNames';
import styles from './DateSelector.module.css';
import Navbar from './NavBar';
import CaptionElement from './CaptionElement';

const bindClasses = classNameBind.bind(styles);
const FIRST_DAY_OF_THE_WEEK = 1;

const classNames = Object.entries(defaultClassNames).reduce(
  (accumulator, [label, classes]) => ({ ...accumulator, [label]: bindClasses(classes.split(' ')) }),
  {},
);

const disabledClass = classNames.disabled;

function isDayEnabled(modifiers) {
  return !modifiers[disabledClass];
}

const DateSelector = ({ value, onChange, min, max, initialPosition, className, yearsSelectorRange } = {}) => {
  const [month, setMonth] = useState(initialPosition);
  const selectedDays = value.length > 1
    ? { from: value[0], to: value[1] }
    : value;
  const disabledDays = {
    after: max,
    before: min,
  };
  const modifiers = {
    [bindClasses('DayPicker-Day--start')]: true,
  };
  const handleChange = (newDate, mods) => {
    if (isDayEnabled(mods)) {
      onChange({
        target: {
          value: [...value, newDate],
        },
      });
    }
  };

  const sharedProps = {
    classNames,
    selectedDays,
    disabledDays,
    modifiers,
    firstDayOfWeek: FIRST_DAY_OF_THE_WEEK,
    navbarElement: Navbar,
    showOutsideDays: true,
    enableOutsideDaysClick: false,
    onDayClick: handleChange,
  };

  return (
    <div className={`${bindClasses('wrapper')} ${className}`} data-ppuc-id="DatePicker.CalendarRangePicker">
      <DayPicker
        {...sharedProps}
        fromMonth={min}
        toMonth={max}
        onMonthChange={setMonth}
        month={month}
        captionElement={date => (
          <CaptionElement
            yearsSelectorRange={yearsSelectorRange}
            date={date.date}
            onChange={setMonth}
            min={min}
            max={max}
          />
        )}
      />
    </div>
  );
};

DateSelector.defaultProps = {
  initialPosition: new Date(),
};

export { DateSelector };
